export default [
  {
    url: '/supplier/insights',
    name: 'Insights',
    icon: 'BarChart2Icon',
    slug: 'insights',
    i18n: 'Insights',
  },
];
